import { useMemo } from 'react';
import { useGetBusinessAddons } from '@/apis/business/addons/hook';
import { isAddonActive } from '@/pages/Business/Setting/Addons/components/addonDisplay';

export function usePhoneNumberAddonAccess() {
  const { data, isLoading } = useGetBusinessAddons();

  return useMemo(() => {
    const addons = data?.data ?? [];
    const smsHostingAddon = addons.find((addon) => addon.code === 'sms_hosting');
    const a2pAddon = addons.find((addon) => addon.code === 'a2p_10dlc');

    return {
      isLoading,
      smsHostingPresent: Boolean(smsHostingAddon),
      smsHostingActive: Boolean(smsHostingAddon && isAddonActive(smsHostingAddon)),
      a2pPresent: Boolean(a2pAddon),
      a2pActive: Boolean(a2pAddon && isAddonActive(a2pAddon))
    };
  }, [data?.data, isLoading]);
}
